import api from './api';
import { Courier, CourierFormData, CourierListItem } from '@/types/courier';

export const vendorCourierApi = {
    async getCouriers(params?: {
        status?: string;
        limit?: number;
        offset?: number;
    }): Promise<{ couriers: CourierListItem[]; total: number; hasMore: boolean }> {
        try {
            const response = await api.get('/vendor/couriers', { params });
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor couriers:', error);
            throw new Error(error.response?.data?.error || 'Kuryeler yüklenemedi');
        }
    },

    async createCourier(courierData: Omit<CourierFormData, 'vendorId'>): Promise<Courier> {
        try {
            const response = await api.post('/vendor/couriers', courierData);
            return response.data;
        } catch (error: any) {
            console.error('Error creating vendor courier:', error);
            throw new Error(error.response?.data?.error || 'Kurye oluşturulamadı');
        }
    },

    async getCourier(courierId: string): Promise<Courier> {
        try {
            const response = await api.get(`/vendor/couriers/${courierId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor courier:', error);
            throw new Error(error.response?.data?.error || 'Kurye yüklenemedi');
        }
    },

    async updateCourier(courierId: string, courierData: Partial<CourierFormData>): Promise<Courier> {
        try {
            const response = await api.put(`/vendor/couriers/${courierId}`, courierData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating vendor courier:', error);
            throw new Error(error.response?.data?.error || 'Kurye güncellenemedi');
        }
    },
};